import { isVarNotEmpty } from './GlobalFunctions'

const timeoutIds: { [key: string]: Nullable<ReturnType<typeof setTimeout>> } = {}

/**
 * Debounce function that delays the execution of the callback until after wait milliseconds have elapsed since the last time it was invoked.
 * This version does not encapsulate the timeoutId, so multiple calls to debounceUnencapsulated will share the same timeoutId.
 * This is intentional for dealing with weird react scenarios.
 *
 * @param key - Unique key to identify the debounce instance.
 * @param callback - Function to debounce.
 * @param wait - Time to wait in milliseconds.
 */
export const debounceUnencapsulated =
    <T extends unknown>(key: string, callback: (...args: T[]) => void, wait: number) =>
    (...args: T[]): void => {
        if (isVarNotEmpty(timeoutIds[key])) {
            clearTimeout(timeoutIds[key] as ReturnType<typeof setTimeout>)
        }

        timeoutIds[key] = setTimeout((): void => callback(...args), wait)
    }
